let PRIMARY_SERVER_URL = `${window.location.protocol}//${window.location.hostname}/api/`;
if (PRIMARY_SERVER_URL.includes("localhost")) {
  PRIMARY_SERVER_URL = process.env.REACT_APP_PRIMARY_SERVER_URL
}
// const SECONDARY_SERVER_URL = process.env.REACT_APP_SECONDARY_SERVER_URL
let activeServerURL = PRIMARY_SERVER_URL


const token = localStorage.getItem("token");

/************************************************************************/
async function connectToAPI(tcontextURL, tmethod, data) {
  try {
    const storedToken = token ?? localStorage.getItem("token");

    const headers = {
      "Content-Type": "application/json",
    };

    // ✅ Only add Authorization if token EXISTS
    if (storedToken) {
      headers.Authorization = `Bearer ${storedToken}`;
    }

    const response = await fetch(activeServerURL + tcontextURL, {
      method: tmethod || "GET",
      headers,
      body: data ? JSON.stringify(data) : undefined,
    });

    console.log("STATUS:", response.status);

    if (response.status === 401) {
      localStorage.setItem("SError", "Session Timed out or Unauthorized Access");
      localStorage.removeItem("token");
      localStorage.removeItem("loggedUserInfo");
      window.location.href = "/login";
      return;
    }

    return response;
  } catch (error) {
    console.error("Error connecting to API:", error);

    // if (activeServerURL === PRIMARY_SERVER_URL) {
    //   activeServerURL = SECONDARY_SERVER_URL;
    //   return connectToAPI(tcontextURL, tmethod, data);
    // } else {
    //   activeServerURL = PRIMARY_SERVER_URL;
    //   return false;
    // }
  }
}

async function connectToClassAPI(tcontextURL, tmethod, data) {
  try {
    const storedToken = token ?? localStorage.getItem("token");

    const headers = {
      "Content-Type": "application/json",
    };

    // ✅ Only attach Authorization if token exists
    if (storedToken) {
      headers.Authorization = `Bearer ${storedToken}`;
    }

    const response = await fetch(activeServerURL + tcontextURL, {
      method: tmethod || "GET",
      headers,
      body: data ? JSON.stringify(data) : undefined,
    });

    console.log("STATUS:", response.status);

    if (response.status === 401) {
      localStorage.setItem("SError", "Session Timed out or Unauthorized Access");
      localStorage.removeItem("token");
      localStorage.removeItem("loggedUserInfo");
      window.location.href = "/login";
      return;
    }

    return response;
  } catch (error) {
    console.error("Error connecting to API:", error);

    // if (activeServerURL === PRIMARY_SERVER_URL) {
    //   activeServerURL = SECONDARY_SERVER_URL;
    //   return connectToClassAPI(tcontextURL, tmethod, data);
    // } else {
    //   activeServerURL = PRIMARY_SERVER_URL;
    //   return false;
    // }
  }
}

/************************************************************************/

export async function loginUser(credentials) {
  console.log(credentials);
  const response = await fetch(activeServerURL + "login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  });
  console.log("Checking login API response");

  return response;
}


/**************BusinesInfo View ***************/
export async function getGBussinessInfo(bId, type) {
  console.log("getGBussinessInfo")

  if (type == "class") {
    return await connectToClassAPI(`businessinfo/${bId}`)
  } else {
    return await connectToAPI(`businessinfo/${bId}`);
  }

}
export async function logOutUser(bId) {
  return await connectToAPI(`login/logout/${bId}`, "GET");
}
export async function saveGBussinessInfo(updates, bId) {
  return await connectToAPI(`businessinfo/${bId}`, "PUT", updates);
}
export async function getPinelabsSettings(gymId) {
  return await connectToAPI(`businessinfo/pinelabs-settings/${gymId}`);
}
export async function getPinelabsSettlementReport(gymId, from, to) {
  const params = new URLSearchParams({ gymId });
  if (from) params.set('from', from);
  if (to)   params.set('to',   to);
  return await connectToAPI(`pinelabs/settlement-report?${params.toString()}`);
}
export async function syncPinelabsSettlement(gymId, from, to) {
  return await connectToAPI('pinelabs/sync-settlement', 'POST', { gymId, from, to });
}
export async function savePinelabsSettlement(ptrid, data) {
  return await connectToAPI(`pinelabs/settlement/${ptrid}`, 'PUT', data);
}
export async function savePinelabsSettings(settings, gymId) {
  return await connectToAPI(`businessinfo/pinelabs-settings/${gymId}`, "PUT", settings);
}
export async function GetBussinessInfo(bId) {
  return await connectToAPI(`businessinfo/accounts/${bId}`);
}
export async function GetBussinessEvents(bId) {
  return await connectToAPI(`businessinfo/accountevents/${bId}`);
}
export async function endBussinessSession(bId, date) {
  console.log("endBussinessSession")

  return await connectToAPI(`businessinfo/updateaccountevents/${bId}`, "PUT", date);
}

export async function createGBussinessInfo(updates) {
  return await connectToAPI(`businessinfo/create`, "PUT", updates);
}

export async function updateCancellationPolicy(updates, bId) {
  return await connectToAPI(`businessinfo/updatecancellationpolicy/${bId}`, "POST", updates);
}

export async function getCustomisableCancellation(bId) {
  return await connectToAPI(`businessinfo/getcustomasaiblecancellation/${bId}`);
}

export async function updatePrivacyPolicy(updates, bId) {
  return await connectToAPI(`businessinfo/updateprivacypolicy/${bId}`, "POST", updates);
}


export async function getCustomisablePrivacy(bId) {
  return await connectToAPI(`businessinfo/getprivacycancellation/policy/${bId}`);
}


export async function createWaiver(updates) {
  return await connectToAPI(`waiver/waiver/0`, "POST", updates);
}
export async function createMultiWaiverForms(updates) {
  return await connectToAPI(`waiver/createMultiWaiverForms`, "POST", updates);
}
export async function verifyWaiverOtp(updates) {
  return await connectToAPI(`waiver/verify/otp`, "POST", updates);
}
export async function confirmWaiverVerifyLink(token, pid) {
  const q = `token=${encodeURIComponent(token || "")}&pid=${encodeURIComponent(pid || "")}`;
  return await connectToAPI(`waiver/verify/link?${q}`, "GET");
}
export async function resendWaiverVerification(updates) {
  return await connectToAPI(`waiver/verify/resend`, "POST", updates);
}
export async function createTransWaiver(updates) {
  return await connectToAPI(`waiver/classtranswaiver/0`, "POST", updates);
}
export async function getWaiver(id) {
  return await connectToAPI(`waiver/waiver/${id}`);
}
export async function getWaiverSettings(uid) {
  return await connectToAPI(`waiver/Wsetting/${uid}`);
}
export async function updateWaiverSettings(updates, bId) {
  console.log("updateWaiverSettings")

  return await connectToAPI(`waiver/Wsetting/${bId}`, "POST", updates);
}
export async function getWaiverSettingsbyGymid(uid) {
  console.log("getWaiverSettingsbyGymid")

  return await connectToAPI(`waiver/Wsetting/gymid/${uid}`);
}
export async function getCheckInfo(bId) {
  return await connectToAPI(`gr/userplans/${bId}`);
}
export async function getGymPlansList(bId) {
  return await connectToAPI(`plans/${bId}`);
}
export async function getGymAddonsList(bId) {
  return await connectToAPI(`addons/${bId}`);
}
export async function saveImportedAddon(updates, bId) {
  return await connectToAPI(`addons/import/${bId}`, "POST", updates);
}
export async function saveUser(updates, bId) {
  return await connectToAPI(`members/${bId}`, "POST", updates);
}
export async function saveStaff(updates, bId) {
  return await connectToAPI(`staff/${bId}`, "POST", updates);
}
export async function saveImportStaff(updates, bId) {
  return await connectToAPI(`staff/imported/${bId}`, "POST", updates);
}

export async function deleteStaff(bId) {
  return await connectToAPI(`staff/${bId}`, "DELETE");
}
export async function createStaff(updates, bId) {
  return await connectToAPI(`staff/${bId}`, "POST", updates);
}
export async function saveInfo(updates, bId) {
  return await connectToAPI(`businessinfo/${bId}`, "PUT", updates);
}

export async function saveTransaction(updates, bId) {
  return await connectToAPI(`transaction/${bId}`, "PUT", updates);
}

export async function getMembersInfo(bId) {
  return await connectToAPI(`gr/userplans/${bId}`);
}
export async function createImportedMember(updates, bId) {
  return await connectToAPI(`members/import/data/${bId}`, "POST", updates);
}

export async function getMemeberProfile(mId) {
  return await connectToAPI(`members/profile/${mId}`);
}
export async function updateMemberDNDvalue(mId, value) {

  return await connectToAPI(`members/updatednd/${mId}`, "POST", value);
}

/************************************ */
export async function getStaffInfo(bId) {
  return await connectToAPI(`staff/${bId}`);
}
export async function getStaffProfile(sId) {
  console.log("getStaffProfile")

  return await connectToAPI(`staff/profile/${sId}`);
}
/***************************** */
export async function getAdminById(uId) {
  return await connectToAPI(`staff/profile/${uId}`);
}
export async function saveAdmin(updates, bId) {
  return await connectToAPI(`staff/${bId}`, "PUT", updates);
}
/******************************************** */

export async function logEvent(data, gymId) {
  console.log("logEvent")

  return await connectToAPI(`logEvent/${gymId}`, "POST", data);
}
export async function getLogEventFilter(data, gymId) {
  return await connectToAPI(`logEvent/filter/${gymId}`, "POST", data);
}
export async function getlogEvent(gymId) {
  return await connectToAPI(`logEvent/${gymId}`);
}
/******************************************** */
export async function CreateAPIsms(data, gymId) {
  return await connectToAPI(`smstemplete/apisms/${gymId}`, "POST", data);
}
export async function DeleteAPIsms(gymId) {
  return await connectToAPI(`smstemplete/apisms/${gymId}`, "DELETE");
}
export async function GetAPIsms(gymId) {
  return await connectToAPI(`smstemplete/apisms/${gymId}`);
}
export async function updateSMSTemp(data, gymId) {
  return await connectToAPI(`smstemplete/${gymId}`, "PUT", data);
}
export async function createSMSTemp(data, gymId) {
  return await connectToAPI(`smstemplete/${gymId}`, "POST", data);
}
export async function resetTemplete(data, gymId) {
  return await connectToAPI(`smstemplete/resettemplete/${gymId}`, "POST", data);
}
export async function resetGateway(gymId) {
  return await connectToAPI(`smstemplete/resetgateway/${gymId}`);
}
export async function getSMSTEMP(gymId) {
  return await connectToAPI(`smstemplete/${gymId}`);
}

export async function updateEmailTemp(data, gymId) {
  return await connectToAPI(`smstemplete/emailTemplete/${gymId}`, "PUT", data);
}
export async function getEmailTEMP(gymId) {
  return await connectToAPI(`smstemplete/emailTemplete/${gymId}`);
}
export async function uploadbanner(updates, tId) {
  return await connectToAPI(`smstemplete/uploadbanner/${tId}`, "POST", updates);
}
export async function getsmsEvents(tId, updates) {
  return await connectToAPI(`smstemplete/smsevents/${tId}`, "POST", updates);
}
export async function updatesmsEvents(tId, updates) {
  return await connectToAPI(`smstemplete/tryagain/${tId}`, "POST", updates);
}

export async function viewbanner(updates, tId) {
  return await connectToAPI(`smstemplete/viewbanner/${tId}`, "GET", updates);
}
export async function getappvariables(id) {
  return await connectToAPI(`smstemplete/appvariables/${id}`, "GET");
}
export async function updateWhatsAppTemp(data, gymId) {
  return await connectToAPI(`whatsapp/${gymId}`, "POST", data);
}
export async function createWhatsAppTemp(data, gymId) {
  return await connectToAPI(`whatsapp/${gymId}`, "POST", data);
}
export async function testwhatAppGateway(data, gymId) {
  console.log(data);
  return await connectToAPI(`whatsapp/testgatway/${gymId}`, "POST", data);
}

export async function resetWhatappTemplete(data, gymId) {
  return await connectToAPI(`whatsapp/resettemplete/${gymId}`, "POST", data);
}
export async function sendWhatsappmessage(gymId, data) {
  return await connectToAPI(`whatsapp/send/${gymId}`, "POST", data);
}
export async function getWhatsappApi(gymId) {
  console.log("getWhatsappApi")

  return await connectToAPI(`whatsapp/whatsappapi/${gymId}`, "GET");
}
export async function CreateWhatsappAPI(data, gymId) {
  return await connectToAPI(`whatsapp/whatsappapi/${gymId}`, "POST", data);
}

export async function resetWhatsAppGateway(gymId) {
  return await connectToAPI(`whatsapp/resetapi/${gymId}`);
}
export async function DeleteWhatsappAPI(gymId) {
  return await connectToAPI(`whatsapp/whatsappapi/${gymId}`, "DELETE");
}
export async function getWhatsAppHistory(id) {
  return await connectToAPI(`whatsapp/whatsapphistory/${id}`);
}
export async function getWhatsAppCampaign(gymId, updates) {
  return await connectToAPI(`whatsapp/whatsappcampaign/${gymId}`, "POST", updates);
}

export async function getWhatsAppNotification(gymId, updates) {
  return await connectToAPI(`whatsapp/whatsappnotification/${gymId}`, "POST", updates);
}
export async function getWhatsAppMemberNotification(gymId, updates) {
  return await connectToAPI(`whatsapp/whatsappmemnotification/${gymId}`, "POST", updates);
}

export async function getWhatsAppTEMP(gymId) {
  return await connectToAPI(`whatsapp/${gymId}`);
}
/************************************************* */
export async function getSinglepageTemp(gymId) {
  return await connectToAPI(`singlepage/${gymId}`);
}
export async function updatesinglepageTemp(updates, gymId) {
  return await connectToAPI(`singlepage/${gymId}`, "POST", updates);
}

/************************************************* */
export async function getSlots(bId) {
  return await connectToAPI(`slots/${bId}`);
}
export async function saveImportedSlot(updates, bId) {
  return await connectToAPI(`slots/imports/${bId}`, "POST", updates);
}

export async function saveSlot(updates, bId) {
  return await connectToAPI(`slots/${bId}`, "POST", updates);
}
export async function savePlan(updates, bId) {
  return await connectToAPI(`plans/${bId}`, "PUT", updates);
}
export async function getPlanProfile(pId) {
  return await connectToAPI(`plans/profile/${pId}`);
}
export async function getPlans(bId) {
  return await connectToAPI(`plans/${bId}`);
}
export async function saveImportedPlan(updates, bId) {
  return await connectToAPI(`plans/imports/${bId}`, "POST", updates);
}
export async function getTransactions(bId, tdata) {
  return await connectToAPI(`transaction/${bId}`, "POST", tdata);
}
export async function transactionSSummary(bId, tdata) {
  return await connectToAPI(`transaction/transsummary/${bId}`, "POST", tdata);
}
export async function planSSummary(bId, tdata) {
  return await connectToAPI(`transaction/plansummary/${bId}`, "POST", tdata);
}
export async function sessionReport(bId, tdata) {
  return await connectToAPI(`members/sessionSummary/get/${bId}`, "POST", tdata);
}
export async function sessionSummary(bId, tdata) {
  return await connectToAPI(`members/sessioncount/${bId}`, "POST", tdata);
}
export async function membersessions(bId) {
  return await connectToAPI(`members/sessionProfile/${bId}`, "GET");
}

export async function clearsessions(bId) {
  return await connectToAPI(`members/clearsession/${bId}`, "POST");
}
export async function allsessions(bId) {
  return await connectToAPI(`members/allsession/${bId}`, "GET");
}
export async function deleteTransactions(bId, tdata) {
  return await connectToAPI(`transaction/delete/${bId}`, "POST", tdata);
}
export async function getTransactionByTIds(bId, tdata) {
  return await connectToAPI(`transaction//transactionbytid/${bId}`, "POST", tdata);
}
export async function editTransactions(bId, tdata) {
  return await connectToAPI(`transaction/edit/${bId}`, "POST", tdata);
}
export async function getMembers(bId) {
  return await connectToAPI(`members/planassigned/${bId}`);
}

export async function getMembersLazy(bId, page, searchQuery) {
  return await connectToAPI(`members/planassigned/${bId}?page=${page}&search=${searchQuery}`);
}
export async function getFormMembersLazy(bId, update) {
  return await connectToAPI(`members/planassignedform/${bId}`, "POST", update);
}
export async function getTokenCount(bId) {
  return await connectToAPI(`transaction/tokencount/${bId}`);
}
export async function getTransactionById(transId) {
  return await connectToAPI(`transaction/byid/${transId}`);
}
export async function getRefundedTransactions(gymId) {
  return await connectToAPI(`transaction/refunds/${gymId}`);
}
export async function getMemberTransactions(mId) {
  return await connectToAPI(`members/transactions/${mId}`);
}
export async function getUniqueMembers(bId, tdata) {
  return await connectToAPI(`members/unique/${bId}`, "POST", tdata);
}
export async function getAllMembers(bId) {
  return await connectToAPI(`members/get/${bId}`);
}
export async function getCheckStaff(bId) {
  return await connectToAPI(`staff/check/get/${bId}`);
}
export async function getCheckMembers(bId, data) {
  return await connectToAPI(`members/check/get/${bId}`, "POST", data);
}
export async function getCheckMembers1(bId, data) {
  return await connectToAPI(`members/checkreport/get/${bId}`, "POST", data);
}
export async function getCheckInReportCount(bId, data) {
  return await connectToAPI(`members/checkincount/${bId}`, "POST", data);
}
export async function getTrainerSummary(bId, data) {
  return await connectToAPI(`members/TrainerSummary/get/${bId}`, "POST", data);
}
export async function getNewCheckMembers(bId, data) {
  return await connectToAPI(`members/check/get1/${bId}`, "POST", data);
}
export async function getRevenueReports(bId, data) {
  return await connectToAPI(`members/revenuereport/${bId}`, "POST", data);
}
export async function getRenewalReports(bId, data) {
  return await connectToAPI(`members//renewalreport/${bId}`, "POST", data);
}

export async function getGroupData(bId, type) {
  return await connectToAPI(`members/group/${bId}?type=${type}`, "GET");
}
export async function updateGroupData(bId, data) {
  return await connectToAPI(`members/group/${bId}`, "POST", data);
}
export async function deleteGroupData(bId, type) {
  return await connectToAPI(`members/group/${bId}?type=${type}`, "DELETE");
}


export async function checkStaff(checkinoutflag, mId) {
  return await connectToAPI(`staff/check/${mId}`, "PUT", checkinoutflag);
}
export async function checkMembers(checkinoutflag, mId) {

  return await connectToAPI(`members/check/${mId}`, "PUT", checkinoutflag);
}
export async function deleteCheckin(mId) {
  return await connectToAPI(`members/check/${mId}`, "DELETE");
}
export async function saveAddon(updates, bId) {
  return await connectToAPI(`addons/${bId}`, "POST", updates);
}
/************************* */
export async function createDiscount(updates, bId) {
  return await connectToAPI(`discount/${bId}`, "POST", updates);
}
export async function updateDiscount(updates, bId) {
  return await connectToAPI(`discount/${bId}`, "PUT", updates);
}
export async function getDiscount(bId) {
  return await connectToAPI(`discount/${bId}`);
}
export async function deleteDiscount(bId) {
  return await connectToAPI(`discount/${bId}`, "DELETE");
}
/*****************************/


export async function deleteMember(mId) {
  return await connectToAPI(`members/${mId}`, "DELETE");
}
export async function getTransaction(tId, bid, token) {
  return await connectToAPI(`transaction/profile/${tId}?gymid=${bid}&&token=${token}`);
}
export async function importingTransactions(bId, updates) {
  return await connectToAPI(`transaction/imports/${bId}`, "POST", updates);
}
export async function refundTransaction(updates, tId) {
  return await connectToAPI(`transaction/profile/${tId}`, "PUT", updates);
}
export async function dueTransaction(tId) {
  return await connectToAPI(`transaction/due/${tId}`);
}
export async function getAddonByPId(aId) {
  return await connectToAPI(`addons/profile/${aId}`);
}
export async function getSlotByPId(aId) {
  return connectToAPI(`slots/profile/${aId}`);
}
export async function deleteAddon(aId) {
  return await connectToAPI(`addons/${aId}`, "DELETE");
}
export async function deletePlan(pId) {
  return await connectToAPI(`plans/${pId}`, "DELETE");
}
export async function getAttendance(id, tdata) {
  return await connectToAPI(`gr/attendance/${id}`, null, tdata);
}
export async function getAttendanceList(id, tdata) {
  return await connectToAPI(`gr/attendance/${id}`, "POST", tdata);
}
export async function getMemberAttendance(id, tdata) {
  return await connectToAPI(`members/memberattendance/${id}`, "POST", tdata);
}
export async function getMemberlatestCheckin(id) {
  return await connectToAPI(`members/latestattendance/${id}`);
}
export async function deleteSlot(sId) {
  return await connectToAPI(`slots/${sId}`, "DELETE");
}
export async function getDashboardData(bId, tdata) {
  return await connectToAPI(`gr/dashboard/${bId}`, "POST", tdata);
}
//****Dashboard widgets*******05122023 Chinna ********/
export async function DBStaffattendance(bId, tdata) {
  return await connectToAPI(`gr/dashboard/staff/${bId}`, "POST", tdata);
}

export async function DBMembershipRenewal(bId, tdata) {
  return await connectToAPI(`gr/dashboard/memRenew/${bId}`, "POST", tdata);
}

export async function DBCheckins(bId, tdata) {
  return await connectToAPI(`gr/dashboard/checkin/${bId}`, "POST", tdata);
}
export async function DBActivMembers(bId, tdata) {
  return await connectToAPI(`gr/dashboard/activeMem/${bId}`, "POST", tdata);
}
export async function DBPayment(bId, tdata) {
  return await connectToAPI(`gr/dashboard/payment/${bId}`, "POST", tdata);
}
export async function DBExpirymemArray(bId) {
  return await connectToAPI(`gr/dashboard/expirymember/${bId}`, "GET");
}
export async function memberTransactions(tId, updates) {
  return await connectToAPI(`transaction/mtrans/${tId}`, "POST", updates);
}
export async function getActiveMembers(bId, data) {
  return await connectToAPI(`members/active/get/${bId}`, "POST", data);
}
export async function verifyEmail(mailID) {
  return await connectToAPI(`staff/verifyemail/${mailID}`);
}
export async function sendVEmail(mailID) {
  console.log("sendVEmail")

  return await connectToAPI(`gr/mails/resendverify/${mailID}`);
}
export async function contactus(id, data) {
  return await connectToAPI(`gr/contactus/mail/${id}`, "POST", data);
}
export async function getGAEventTracker() {
  return await connectToAPI(`gr/gaeventtracker`);
}

export async function DBOverdueCheckins(bId, tdata) {
  return await connectToAPI(`gr/dashboard/overduecheckins/${bId}`, "POST", tdata);
}
export async function numberSignUp(updates) {
  return await connectToAPI(`businessinfo/phonenumber`, "POST", updates);
}

export async function authorzationOtp(updates) {
  return await connectToAPI(`businessinfo/authorazationotp`, "POST", updates);
}


export async function emailVerify(updates) {
  return await connectToAPI(`businessinfo/emailotpverify`, "POST", updates);
}
export async function numbermessage(updates) {
  return await connectToAPI(`businessinfo/urlnumber`, "POST", updates);
}

export async function numpaymentalertmessage(updates) {
  return await connectToAPI(`businessinfo/paymentalert`, "POST", updates);
}

export async function uploadlogo(formData, tId) {

  return await connectToAPI(`businessinfo/uploadlogo/${tId}`, "POST", formData);
}
export async function viewlogo(updates, tId) {
  return await connectToAPI(`businessinfo/viewlogo/${tId}`, "Get", updates);
}
export async function pdfdownloader(updates, tId) {
  return await connectToAPI(`transaction/pdfD/${tId}`, "POST", updates);
}

export async function uploadInvoice(updates, tId) {
  return await connectToAPI(`transaction/upload/${tId}`, "POST", updates);
}

/**
 * created on [5-7-2024]
 * Uploads payment link updates for a transaction identified by tId.
 * @param {Object} updates - The updates to be uploaded.
 * @param {string} tId - The transaction ID.
 *  @description:-this api is for uploading invoice while paymentlink method
 * @returns {Promise} A promise that resolves when the upload is complete.
 */
export async function uploadInvoicePaymentlink(updates, tId) {
  return await connectToAPI(`transaction/uploadpayment/${tId}`, "POST", updates);
}

export async function downloadInvoice(updates, tId) {
  return await connectToAPI(`transaction/download/${tId}`, "GET", updates);
}
/**
 * created on [5-7-2024]
 * @param {Object} updates - The updates send as request to function to get html content.
 *  @description:-getInvoicehtmlcontent api for geting html content for invoice.
 * @returns {Promise} A promise that resolves when the htmlcontent received as response.
 */
export async function getInvoicehtmlcontent(updates, tId) {
  return await connectToAPI(`transaction/invoicecontent/${tId}`, "POST", updates);
}
export async function membertable(id, updates) {
  return await connectToAPI(`members/allmembers/${id}`, "POST", updates);
}
export async function memberActiveTransactions(id) {
  return await connectToAPI(`members/activetransactions/${id}`);
}

export async function sendReceiptMail(bId, emailid, reciptLink, logo, token) {
  const emailList = emailid.join(',');
  // console.log(emailList, "99999999999", bId, emailid, reciptLink, logo);
  // console.log(typeof content);
  const updates = {
    link: reciptLink,
    mail: emailList,
    logo: logo,
    token: token,

  }
  return await connectToAPI(`gr/mails/receiptmail/${bId}`, "POST", updates);
}
export async function pauseMemberShip(bId, data) {
  return await connectToAPI(`members/pause/${bId}`, "POST", data);
}
export async function extendMemberShip(bId, data) {
  return await connectToAPI(`members/extend/${bId}`, "POST", data);
}
export async function resumeMemberShip(bId, data) {
  return await connectToAPI(`members/resume/${bId}`, "POST", data);
}
export async function suspendMemberShip(bid) {
  return connectToAPI(`members/suspend/${bid}`);
}
export async function activateMemberShip(bid) {
  return connectToAPI(`members/suspendActivate/${bid}`);
}

export async function getLocation(bId) {
  console.log("getLocation")

  return await connectToAPI(`geolocation/${bId}`);
}
export async function updateLocation(bId, updates) {
  console.log("updateLocation")

  return await connectToAPI(`geolocation/${bId}`, "POST", updates);
}

export async function updatePaymentLinkSetting(bId, updates) {
  return await connectToAPI(`paymentlink/paymentlinksetting/${bId}`, "POST", updates);
}
export async function getEADeviceSettings(gymId) {
  return await connectToAPI(`easerver/devicesettings/${gymId}`);
}
export async function toggleEADevice(gymId, enabled) {
  return await connectToAPI(`easerver/bsetting/${gymId}`, "POST", { enabled, gymId });
}
export async function regenerateEAKey(gymId) {
  return await connectToAPI(`easerver/bsetting/${gymId}`, "POST", { enabled: true, gymId, regenerate: true });
}
export async function updateEADeviceSettings(gymId, settings) {
  return await connectToAPI(`easerver/devicesettings/${gymId}/update`, "POST", settings);
}


export async function getPaymentLinkSetting(bId) {
  console.log("getPaymentLinkSetting")

  return await connectToAPI(`paymentlink/paymentlinksetting/${bId}`);
}
export async function confirmPaymentLink(bId, updates) {
  return await connectToAPI(`paymentlink/generatepaymentlink/${bId}`, "POST", updates);
}
export async function sendPaymentLink(bId, updates) {
  return await connectToAPI(`paymentlink/sendpaymentlink/${bId}`, "POST", updates);
}
export async function checkPaymentStatus(bId) {
  return await connectToAPI(`paymentlink/checkpaymentstatus/${bId}`);
}
export async function reqPaymentStatus(bId) {
  return await connectToAPI(`paymentlink/requestpaymentstatus/${bId}`);
}
export async function getPaymentUrl(uid) {
  return await connectToAPI(`paymentlink/url/${uid}`);
}
export async function getCompressPaymentLink(uid) {
  return await connectToAPI(`paymentlink/uniqueid/${uid}`);
}
export async function reqConfirmPaymentStatus(uid) {
  console.log("reqConfirmPaymentStatus")

  return await connectToAPI(`paymentlink/requestconfirmpaymentstatus/${uid}`);
}
export async function getAllPaymentTransactions(uid) {
  return await connectToAPI(`paymentlink/alltransactions/${uid}`);
}
export async function deletePaymentLinkTrans(uid) {
  return await connectToAPI(`paymentlink/delete/${uid}`);
}
//Reset Password api
export async function resetPassword(updates) {
  return await connectToAPI(`staff/login/getresetPassword`, "POST", updates);

}
//confirm password api
export async function confirmPassword(updates, id) {
  return await connectToAPI('staff/login/restpassword', "POST", updates)
}
export async function getActiveMembersCount(bId, updates) {
  return await connectToAPI(`plans/activereport/${bId}`, "POST", updates);
}
export async function getActiveMembersCountByRow(bId, updates) {
  return await connectToAPI(`plans/activereportrowdata/${bId}`, "POST", updates);
}
export async function checkEmail(bId, updates) {
  return await connectToAPI(`staff/emailCheck/${bId}`, "POST", updates);
}
// pricing plans 
export async function getPricingPlansById(uid) {
  console.log("getPricingPlansById", uid)

  return await connectToAPI(`pricingplan/planbyid/${uid}`);
}
export async function getAllPricingPlans(id) {
  return await connectToAPI(`pricingplan/allplans/${id}`);
}
// subscriptions
export async function createSubscriptionPlan(uid, updates) {
  return await connectToAPI(`subscription/create/${uid}`, "POST", updates);
}
export async function getSubscriptionPlans(bid,) {
  return await connectToAPI(`subscription/getsubinfo/${bid}`);
}
export async function cancelSubscriptionPlan(bid, updates) {
  return await connectToAPI(`subscription/cancel/${bid}`, "POST", updates);
}
export async function checkrecoveryIdCheck(recoveryId) {
  return await connectToAPI(`staff/password/recoveryIdCheck`, "POST", recoveryId)
}

//generateNewPassword
export async function generateNewPassword(updates) {
  return await connectToAPI(`staff/password/generatepassword`, "POST", updates);
}
export async function customPremium(updates) {
  return await connectToAPI(`gr/mails/contactmail`, "POST", updates);
}

export async function gymcontactus(updates) {
  return await connectToAPI(`gr/mails/gymcontactmail`, "POST", updates);
}
//multigym
export async function creategyms(updates, bId) {
  return await connectToAPI(`businessinfo/creategyms/${bId}`, "POST", updates)
}


//getexistgym
export async function getexistgym(updates) {
  return await connectToAPI('businessinfo/getexistgym', "POST", updates)
}


export async function verifymailotp(updates) {
  return await connectToAPI('businessinfo/verifymailotp', "POST", updates)
}



//getmultigyms
export async function getmultigyms(updates) {
  console.log("getmultigyms")

  return await connectToAPI('businessinfo/getmultigyms', "POST", updates)
}

//deleteAddGym
export async function deleteAddGym(id) {
  return await connectToAPI("businessinfo/deleteAddGym", "POST", id)
}

//getEnvFileData

export async function getEnvFileData() {
  return await connectToAPI("businessinfo/env-file/data")
}


//getBusinessName

export async function getBusinessName(updates) {
  return await connectToAPI("members/getBusinessName/getBusinessName", "POST", updates)
}




// /***************segment api's********** */
export async function createSegment(updates, bId) {
  return await connectToAPI(`segment/${bId}`, "POST", updates);
}
export async function updateSegment(updates, bId) {
  return await connectToAPI(`segment/${bId}`, "PUT", updates);
}
export async function getSegment(bId) {
  return await connectToAPI(`segment/${bId}`);
}
export async function deleteSegment(bId) {
  return await connectToAPI(`segment/${bId}`, "DELETE");
}
export async function createCampaign(bId, updates) {

  return await connectToAPI(`segment/schedulecampaign/${bId}`, "POST", updates);
}
export async function updateCampaign(updates, bId) {
  return await connectToAPI(`segment/schedulecampaign/${bId}`, "PUT", updates);
}
export async function getCampaign(bId, segmentid) {

  return await connectToAPI(`segment/schedulecampaign/${bId}?segmentid=${segmentid}`, "GET");
}

export async function getcampaignAnalytics(bid, updates) {
  return await connectToAPI(`whatsapp/whatsappcampaignbycampid/${bid}`, "POST", updates);

}

export async function getcampaignAnalyticsReport(bid, updates) {
  return await connectToAPI(`segment/campaignanalytics/${bid}`, "POST", updates);

}

export async function getMembersbyids(bid, updates) {
  return await connectToAPI(`segment/membersbyids/${bid}`, "POST", updates);

}
export async function deleteCampaign(bId, cid) {
  return await connectToAPI(`segment/schedulecampaign/${bId}?campaignid=${cid}`, "DELETE");
}

export async function getSegmentMembers(bId, sId) {
  return await connectToAPI(`segment/segmentmembers/${bId}?segmentid=${sId}`);
}

export async function updateMembersDND(bId, updates) {
  return await connectToAPI(`segment/updatemembersdnd/${bId}`, "POST", updates);
}


// /*****************************/

// /***************class Booking api's********** */
export async function createClass(bId, updates) {
  return await connectToClassAPI(`class/${bId}`, "POST", updates);
}
// export async function update(updates, bId) {
//   return await connectToAPI(`segment/${bId}`, "PUT", updates);
// }
export async function getClassList(bId, updates) {
  // console.log(updates);
  return await connectToClassAPI(`class/allclasses/${bId}`, 'POST', updates);
}

export async function getClass(bId) {
  return await connectToClassAPI(`class/${bId}`);
}
export async function deleteClass(bId, cid) {
  return await connectToClassAPI(`class/${bId}?classid=${cid}`, "DELETE");
}
export async function createCancellationPolicy(bId, updates) {
  return await connectToClassAPI(`class/policy/${bId}`, "POST", updates);
}

export async function getCancellationPolicy(bId) {
  return await connectToClassAPI(`class/policy/${bId}`);
}
export async function deleteCancellationPolicy(bId, pid) {
  return await connectToClassAPI(`class/policy/${bId}?policyid=${pid}`, "DELETE");
}

export async function createTrainer(bId, updates) {
  return await connectToClassAPI(`class/trainer/${bId}`, "POST", updates);
}

export async function getTrainer(bId) {
  return await connectToClassAPI(`class/trainer/${bId}`);
}
export async function deleteTrainer(bId, tid) {
  return await connectToClassAPI(`class/trainer/${bId}?trainerid=${tid}`, "DELETE");
}

export async function CreateSchedule(bId, updates) {
  return await connectToClassAPI(`class/schedule/${bId}`, "POST", updates);
}
export async function getSchedule(bId) {
  return await connectToClassAPI(`class/schedule/${bId}`);
}
export async function deleteSchedule(bId, sid, isapplied) {
  return await connectToClassAPI(`class/schedule/${bId}?scheduleid=${sid}&isapplied=${isapplied}`, "DELETE");
}

export async function verifyNumber(updates) {
  return await connectToClassAPI(`businessinfo/numberverify`, "POST", updates);
}

export async function memberByNumber(bId, updates) {
  console.log(updates, "updates");

  return await connectToClassAPI(`members/by-number/${bId}`, "POST", updates);
}

export async function createClassTransaction(bId, update) {
  return await connectToClassAPI(`class/transaction/${bId}`, "PUT", update);
}
export async function getClassTransactions(bId, tdata) {
  return await connectToClassAPI(`class/transaction/${bId}`, "POST", tdata);
}

export async function getClassTransactionbyTid(tId, bId) {


  return await connectToClassAPI(`class/transactionbyid/${tId}?gymid=${bId}`);
}

export async function getClassTransactionbyNumber(bId, tdata) {

  return await connectToClassAPI(`class/transaction-by-number/${bId}`, "POST", tdata);
}


export async function deleteClassTransactions(bid, tid) {
  // console.log(bid, tid, '3244444444444444444444');

  return await connectToClassAPI(`class/transaction/${bid}?transid=${tid}`, "DELETE");
}

export async function checkMembershipDiscount(bId, update) {
  return await connectToClassAPI(`class/checkmembership/${bId}`, "POST", update);
}

export async function getBussinessInfobyUrl(url) {
  return await connectToClassAPI(`class/businessdetail/${url}`);
}

export async function createMembers(bid, membersdata) {
  return await connectToClassAPI(`members/addmembers/${bid}`, "PUT", membersdata);
}
export async function getclassDashboardInfo(bId) {
  return await connectToClassAPI(`class/classdashboard/${bId}`);
}

export async function uploadClassInvoice(tId, update) {
  return await connectToClassAPI(`class/uploadclassinvoice/${tId}`, "POST", update);
}

export async function getClassInvoicehtmlcontent(tId, gid) {
  return await connectToClassAPI(`class/invoicecontent/${tId}?Gid=${gid}`);
}
export async function createclassRefund(gid, Update) {
  return await connectToClassAPI(`class/refund/${gid}`, "PUT", Update);
}

export async function createRazorpayOrder(Update) {
  return await connectToClassAPI(`razorpay/create-order`, "POST", Update);
}

export async function verifyRazorpayOrder(Update) {
  return await connectToClassAPI(`razorpay/verify-payment`, "POST", Update);
}

export async function downloadclassinvoice(update) {
  return await connectToClassAPI(`class/downloadclassinvoice/${update.bid}`, "POST", update)
}
export async function createRazorpayGateway(gid, Update) {
  return await connectToClassAPI(`razorpay/updategateway/${gid}`, "PUT", Update);
}

// /*****************************/



//sendCheckInQrCode

export async function sendCheckInQrCode(bid, updates) {
  return await connectToAPI(`members/sendCheckInQrCode/${bid}`, "POST", updates)
}

export async function downloadcheckinQrCode(mid, updates) {
  return await connectToAPI(`members/downloadqrcode/${mid}`, "POST", updates)
}

export async function getcheckinQrCode(mid, updates) {
  return await connectToAPI(`members/uploadcheckinqrcode/${mid}`, "POST", updates)
}
export async function renewalAleretTrans(updates) {
  return await connectToAPI(`transaction/get/renewalAleretTrans`, "POST", updates);
}

export async function updateTransaction(bId, updates) {
  return await connectToAPI(`transaction/updateparentname/${bId}`, "PUT", updates);
}

export async function updateTransactionPaymentMode(bId, payload) {
  return await connectToAPI(`transaction/updatepaymentmode/${bId}`, "PUT", payload);
}
export async function getManagementPricingPlans() {
  return await connectToAPI(`pricingplan/managemant/getallplans`);
}
export async function createOrderSubscriptionPlan(updates) {
  return await connectToAPI(`subscription/createorder`, "POST", updates);
}
export async function createOrderSubscriptionmgmtPlan(updates) {
  return await connectToAPI(`pricingplan/managemant/createorder`, "POST", updates);
}
export async function createmgmtSubscription(updates) {
  return await connectToAPI(`pricingplan/managemant/createsubscription`, "POST", updates);
}
export async function getmgmtSubscriptionByGymId(mid) {
  return await connectToAPI(`pricingplan/managemant/getsubscriptionbygid/${mid}`);
}
export async function getLatestSubscriptionPlan(bid) {
  return await connectToAPI(`subscription/getlatestsubinfo/${bid}`);
}
export async function createDemo(updates) {
  return await connectToAPI(`googlemeet/generategooglemeet`, "POST", updates)
}
export async function randomTid() {
  return await connectToAPI(`transaction/transcation/randomtid`, "GET")
}
export async function CreateVistorInfo(updates) {
  return await connectToAPI(`businessinfo/vistors`, "POST", updates)
}

export async function createSubDomain(bid, Update) {
  return await connectToAPI(`businessinfo/subdomains/${bid}`, "PUT", Update);
}
export async function getAllSubDomain(domain) {
  console.log("getAllSubDomain")

  return await connectToAPI(`businessinfo/subdomains/${domain}`, "GET");
}

export async function saveGymCoordinates(bid, updates) {
  console.log("saveGymCoordinates")

  return await connectToAPI(`businessinfo/savegymcoordinates/${bid}`, "POST", updates)
}
//getGymCoordinates
export async function getGymCoordinates(bid) {
  console.log("getGymCoordinates")

  return await connectToAPI(`businessinfo/getgymcoordinates/${bid}`, "GET")
}
export async function createGymHomePage(bid, Update) {
  return await connectToAPI(`gymhome/${bid}`, "POST", Update);
}

export async function getGymHomePage(bid) {
  return await connectToAPI(`gymhome/${bid}`, "GET");
}

export async function createAnnouncement(bid, Update) {
  return await connectToAPI(`businessinfo/announcement/${bid}`, "POST", Update);
}

export async function getAnnouncements(gymid) {
  return await connectToAPI(`businessinfo/announcement/${gymid}`, "GET");
}

export async function UpdateMembershipSessions(bid, updates) {
  return await connectToAPI(`members/sessions/${bid}`, "POST", updates)
}

export async function getGSTAddress(gstin) {
  return await connectToAPI(`businessinfo/gst-lookup/${gstin}`, "GET");

}
//getMultiGymsAndPlans
export async function getMultiGymsAndPlans(gymid) {
  console.log("getMultiGymsAndPlans")

  return await connectToAPI(`businessinfo/getMultiGymsAndPlans/${gymid}`, "GET");
}



//multiGymSettingSave
export async function multiGymSettingSave(updates) {
  return await connectToAPI(`businessinfo/multigym/settings`, "POST", updates)
}


//validateMultiGymCheckin
export async function validateMultiGymCheckin(updates) {
  return await connectToAPI(`businessinfo/multigym/validatecheckins`, "POST", updates)
}

//sendWaiverLink
export async function sendWaiverLink(updates) {
  return await connectToAPI(`members/multigym/sendWaiverLink`, "POST", updates)
}


//updateMemberCredentials
export async function updateMemberCredentials(updates) {
  return await connectToAPI(`members/multigym/updateMemberCredentials`, "POST", updates)
}

//getGlobalPlanAccess
export async function getGlobalPlanAccess(updates) {
  console.log("getGlobalPlanAccess")

  console.log("updates", updates)
  return await connectToAPI(`businessinfo/multigym/getGlobal/PlanAccess`, "POST", updates)
}

//waiverStatus
export async function waiverStatus(updates) {
  return await connectToAPI(`members/multigym/waiverStatus`, "POST", updates)
}
export async function getBookedsessionsbymid(bid, updates) {
  return await connectToAPI(`class/getBookedactivesesssionbyMid/${bid}`, "POST", updates)
}
export async function classCheckinsByGymID(bid, updates) {
  return await connectToAPI(`members/classcheckins/${bid}`, "POST", updates)
}
export async function getMembersbyGymid(updates) {
  return await connectToAPI(`members/membersbygymid/12`, "POST", updates)
}

export async function searchPartnerGymMembers(updates) {
  console.log("searchPartnerGymMembers", updates)
  return await connectToAPI(`members/multigym/searchPartnerGymMembers`, "POST", updates)
}

export async function createMemberFromWaiver(updates) {
  console.log("updatescreatewaiver", updates)
  return await connectToAPI(`waiver/createMemberFromWaiver`, "POST", updates);
}

export async function sendClassConfirmation(updates) {
  return await connectToAPI(`class/send/classconfirmation`, "POST", updates);
}

export async function DBInactiveActiveMembers(bId, tdata) {
  return await connectToAPI(`gr/dashboard/DBInactiveActiveMembers/${bId}`, "POST", tdata);
}

/**************Whatsapp Business API(S)************/


export async function getMemberOverdueCheckins(gymId, updates) {
  return await connectToAPI(`members/overdue/checkins/${gymId}`, "POST", updates);
}



export async function writeOffOverdueCheckins(updates) {

  return await connectToAPI(`members/overdue/deletechekin`, "POST", updates)
}


export async function getRoleAccess(module, rolevalue) {
  return await connectToAPI(`businessinfo/roleaccess/${module}?rolevalue=${rolevalue}`)

}

export async function getClassDetails(classId) {
  return await connectToAPI(`class/classdetails/${classId}`);
}


export async function getStaffByGym(updates) {
  return await connectToAPI(`businessinfo/getStaff/ByGym`, "POST", updates);
}

/**************Whatsapp Business API(S)************/
export async function createWhatsAppPartner(gymid, updates) {
  return await connectToAPI(`whatsappservice/register/${gymid}`, "POST", updates);
}

export async function WhatsAppPartnerStatus(numberid) {
  return await connectToAPI(`whatsappservice/status/${numberid}`);
}

export async function getwhatsAppPartnerInfo(gymid) {
  return await connectToAPI(`whatsappservice/status/${gymid}`);
}

export async function createwhatsAppTemplates(updates) {
  return await connectToAPI(`whatsappservice/template`, "PUT", updates);
}

export async function submitTemplateToMeta(updates) {
  return await connectToAPI(`whatsappservice/template/submit`, "POST", updates);
}

export async function importWhatsAppTemplates(updates) {
  return await connectToAPI(`whatsappservice/template/import`, "POST", updates);
}


export async function getwhatsAppTemplates(updates) {
  return await connectToAPI(`whatsappservice/template`, "POST", updates);
}

export async function getwhatsAppTemplatesById(templateid) {
  return await connectToAPI(`whatsappservice/template/${templateid}`);
}

export async function deletewhatsAppTemplate(templateid) {
  return await connectToAPI(`whatsappservice/template/${templateid}`, "DELETE");
}


export async function createMetaCampaign(campaignData) {
  return await connectToAPI(`metacampaign/create`, "POST", campaignData);
}

export async function sendMetaCampaign(campaignId, gymId) {
  console.log(campaignId, gymId);

  return await connectToAPI(`metacampaign/${campaignId}/send`, "POST", { gymId });
}

export async function sendMetaCampaignDirect(campaignData) {
  return await connectToAPI(`metacampaign/send-campaign`, "POST", campaignData);
}

export async function getMetaCampaign(campaignData) {
  return await connectToAPI(`metacampaign/list`, "POST", campaignData);
}

export async function getMetaCampaignDetails(update) {
  return await connectToAPI(`metacampaign/details`, "POST", update);
}

export async function getMetaCampaignContacts(campaignData) {
  return await connectToAPI(`metacampaign/contacts`, "POST", campaignData);
}

export async function getConversations(gymid) {
  return await connectToAPI(`metachart/conversations/${gymid}`, "GET");
}

export async function getConversationStats(gymid) {
  return await connectToAPI(`metachart/conversations/stats/${gymid}`, "GET");
}


export async function searchConversations(searchTerm, gymid) {
  return await connectToAPI(`metachart/conversations/search?q=${encodeURIComponent(searchTerm)}&&gymid=${gymid}`, "GET");

}

export async function sendMessage(conversationId, text, extraBody = {}) {
  return await connectToAPI(`metachart/conversations/${conversationId}/send`, "POST", {
    text,
    ...extraBody,
  });
}

export async function markAsRead(conversationId) {
  return await connectToAPI(`metachart/conversations/${conversationId}/read`, "POST");
}

export async function getConversationMessages(conversationId) {
  return await connectToAPI(`metachart/conversations/${conversationId}/messages`, "GET");

}

export async function getleadsList(status, search, priority, gymId, page, limit) {
  const params = new URLSearchParams();
  params.set("gymId", gymId);
  params.set("status", status != null ? status : "all");
  if (search) params.set("search", search);
  if (priority && priority !== "all") params.set("priority", priority);
  params.set("page", String(page != null ? page : 1));
  params.set("limit", String(limit != null ? limit : 10));
  return await connectToAPI(`leads/?${params.toString()}`, "GET");
}
export async function getleadstatus(gymId) {
  return await connectToAPI(`leads/stats/${gymId}`, "GET");
}

export async function getleadDetails(leadId) {
  return await connectToAPI(`leads/${leadId}`, "GET");
}

/** Multipart upload; returns raw Response (caller checks ok / json). */
export async function uploadWhatsAppLeadMedia(gymId, file) {
  const storedToken = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("file", file);
  formData.append("gymId", gymId);
  return fetch(activeServerURL + "leads/upload-whatsapp-media", {
    method: "POST",
    headers: storedToken ? { Authorization: `Bearer ${storedToken}` } : {},
    body: formData,
  });
}

export function getLeadMessageMediaUrl(messageId) {
  return activeServerURL + `leads/messages/${messageId}/media`;
}

export async function updatelead(leadId, update) {
  return await connectToAPI(`leads/${leadId}`, "PUT", update);
}

/** Create Member + MemberView from lead; sets lead.memberId and status Member. */
export async function convertLeadToMember(leadId) {
  return await connectToAPI(`leads/${leadId}/convert`, "POST", {});
}

export async function markLeadAsRead(leadId, update) {
  return await connectToAPI(`leads/${leadId}/read`, "POST", update);
}
export async function addLeadNotes(leadId, update) {
  return await connectToAPI(`leads/${leadId}/notes`, "POST", update);
}

export async function covertLead(leadId, update) {
  return await connectToAPI(`leads/${leadId}/notes`, "POST", update);
}

export async function sendQuote(update) {
  return await connectToAPI(`quotes/create`, "POST", update);
}
export async function resendQuote(quoteId, update) {
  return await connectToAPI(`quotes/${quoteId}/resend`, "POST", update);
}
export async function getQuote(quoteId) {
  return await connectToAPI(`quotes/lead/${quoteId}`);
}
export async function deleteQuote(quoteId) {
  return await connectToAPI(`quotes/${quoteId}`, "DELETE");
}
export async function editQuote(quoteId, update) {
  return await connectToAPI(`quotes/${quoteId}/edit`, "POST", update);
}

export async function downloadQuoteUrl(quoteId, update) {
  return await connectToAPI(`quotes/downloadquoteUrl/${quoteId}`, "POST", update);
}
export async function saveQuoteDraft(quoteData) {
  return await connectToAPI(`quotes/save-draft`, "POST", quoteData);
}
export async function getWhatAppDBCampaigns(gymid, update) {
  return await connectToAPI(`whatsappservice/dashboard/campaigns/${gymid}`, "POST", update);
}
export async function getWhatAppDBTemplates(gymid, update) {
  return await connectToAPI(`whatsappservice/dashboard/templates/${gymid}`, "POST", update);
}
export async function getWhatAppDBMessages(gymid, update) {
  return await connectToAPI(`whatsappservice/dashboard/messages/${gymid}`, "POST", update);
}

export async function createEmbeddedSignup(gymid, updates) {
  return await connectToAPI(`whatsappservice/embedded-signup/create`, "POST", updates);
}

export async function checkExistingWABA(gymid) {
  return await connectToAPI(`whatsappservice/waba-status/${gymid}`);
}


export async function checkMetaConnection(gymid) {
  return await connectToAPI(`whatsappservice/status/${gymid}`);
}

export async function metaOAuthComplete(update) {
  return await connectToAPI(`whatsappservice/complete-oauth`, "POST", update);
}

export async function disconnectWhatsAppMeta(gymid) {
  return await connectToAPI(`whatsappservice/disconnect/${gymid}`, "POST");
}





export async function gustPassReferalCheck(updates) {
  return await connectToAPI(`members/gustPass/ReferalCheck`, "POST", updates);
}




export async function getMembersWithNoPlans(id, page, search) {
  return await connectToAPI(`members/with-no-plans/${id}?page=${page}&search=${search}`, "GET");
}


export async function getGuestPassReservations(data) {
  return await connectToAPI(`members/guestpass/reservations`, "POST", data);
}


export async function getGuestPassLeaderboard(gymId, period = 'all') {
  return await connectToAPI(`members/guestpass/leaderboard?gymId=${gymId}&period=${period}`, "GET");
}


export async function getGuestPassHistory(memberId, gymId) {
  return await connectToAPI(`members/guestpass/history/${memberId}?gymId=${gymId}`, "GET");
}

export async function getMembersByGymIdPOS(bId, page, searchQuery, waiver) {
  return await connectToAPI(`members/selectmember/${bId}?page=${page}&search=${searchQuery}&waiver=${waiver}`);
}


export async function getGuestPassBalance(memberId) {
  return await connectToAPI(`members/guestpass/balance/${memberId}`, "GET");
}


export async function UpdateMembershipGuestPass(bid, updates) {
  return await connectToAPI(`members/membership/guestpass/${bid}`, "POST", updates);
}


export async function getSessionSharingHistory(memberId, gymId) {
  return await connectToAPI(`members/session-sharing/${memberId}/${gymId}`, "GET");
}


export async function verifyEmailOtpForSignup(updates) {
  return await connectToAPI(`businessinfo/verify/signup/otp/123`, "POST", updates);
}

export async function getUserByEmail(staffId, updates) {
  return await connectToAPI(`staff/getuser/byemail/${staffId}`, "POST", updates);
}


export async function getUserByStaffId(staffId) {
  console.log("staffId", staffId)
  return await connectToAPI(`businessinfo/get-user-by-staff-id/${staffId}`);
}

export async function sendOtptoVerify(updates) {
  return await connectToAPI('businessinfo/verify/Mailotp', "POST", updates)
}


export async function verifyEmailStatus(id, updates) {
  return await connectToAPI(`businessinfo/website/emailstaus/update/${id}`, "PUT", updates);
}


export async function updateMemberPlan(gymid, payload) {

  return await connectToAPI(`transaction/updateMembership/Plan/${gymid}`, "PUT", payload);
}

